import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["widgetFluidHeight", "widgetFixedWidth", "widgetFixedHeight", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
var styles = {
  "fluidHeight": "WidgetCmp-fluidHeight_1OTOU",
  "fixedWidth": "WidgetCmp-fixedWidth_t659k",
  "fixedHeight": "WidgetCmp-fixedHeight_17KOP"
};
function Widget(_ref) {
  var _clsx;
  var widgetFluidHeight = _ref.widgetFluidHeight,
    widgetFixedWidth = _ref.widgetFixedWidth,
    widgetFixedHeight = _ref.widgetFixedHeight,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.fluidHeight, widgetFluidHeight), _defineProperty(_clsx, styles.fixedWidth, widgetFixedWidth), _defineProperty(_clsx, styles.fixedHeight, widgetFixedHeight), _clsx), className);

  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/React.createElement(Base, _extends({
    className: rootClasses
  }, extraProps));
}
export default Widget;